<script setup>

import { ErrorMessage } from 'vee-validate';

const props = defineProps({
  label: {
    required: true,
  },
  autoCompleteType: {
    default: null,
  },
  id: {
    required: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  options: {
    default: [
      {
        id: 'none',
        label: 'None',
        value: 'none',
      },
    ],
    required: true,
  },
});

const model = defineModel();

</script>

<template>
  <div class="mt-6">
    <label
      v-if="props.isRequired"
      :for="props.id"
      class="block text-sm font-medium text-primary"
    >{{ label }} *</label>
    <label
      v-else
      :for="props.id"
      class="block text-sm font-medium text-primary"
    >{{ label }}</label>
    <div class="mt-3">
      <select
        v-model="model"
        :required="props.isRequired"
        class="block w-full bg-transparent text-primary border border-primary text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        <option
          class="bg-basecolor text-primary"
          disabled
          value=""
        />
        <option
          class="bg-basecolor text-primary"
          v-for="option in props.options"
          :value="option.value"
          :key="option.id"
        >
          {{ option.label ? option.label : ( option.labelI18n ? $t(option.labelI18n) : "ERR: NO LABEL") }}
        </option>
      </select>

      <slot />
      <ErrorMessage
        :name="props.id"
        class="px-2 mt-2 text-sm text-red-400 dark:text-red-400"
        as="p"
      />
    </div>
  </div>
</template>
